import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import { trackV2 } from 'utils/analytics';
import reducer from './reducers';
import Form from './components/Form';
import Terms from './components/Terms';
import SummaryContainer from './components/SummaryContainer';
import styles from './index.scss';
import { analyticsDataProps } from './shared/prop-types';

class Checkout extends React.Component {
  store = createStore(reducer, this.props, applyMiddleware(thunk));

  componentDidMount() {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'screen_enter',
      properties: { ...this.props.analytics_data }
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <>
          <div className={styles.container}>
            <SummaryContainer />
            <Form />
          </div>
          <Terms />
        </>
      </Provider>
    );
  }
}

Checkout.propTypes = {
  analytics_data: analyticsDataProps.isRequired
};

export default Checkout;
